import { FC, HTMLAttributes, ReactNode } from 'react'
import { useGetTranslations } from '@/root/shared-hooks'
import { Button } from '@/root/ui/tuuleliinid'

interface CookiesBannerProps extends HTMLAttributes<HTMLElement> {
  onAgree: () => void
  textField: ReactNode
}

export const CookiesBanner: FC<CookiesBannerProps> = ({ textField, onAgree }) => {
  const { getTranslation } = useGetTranslations()

  return (
    <section className="fixed inset-x-0 bottom-0 z-50 flex w-full items-center justify-center bg-white p-4 md:static md:h-16">
      <span className="text-neutral-darker w-full text-xs md:w-auto md:text-xs">{textField}</span>
      <Button onClick={onAgree} variant="default" className="bg-neutral-medium-lighter m-4 h-8 w-28 text-xs text-white">
        {getTranslation('cookiesAgreement')}
      </Button>
    </section>
  )
}
